export default __webpack_public_path__ + "static/media/BBPlan_Logo.a0150538.png";